import './Licenses.css'
import { ILicenseStats, ILicensesInfo } from 'src/Utils/Hooks/ManageLicenses/useGetLicensesInfo';
import LicenseInfo from '../LicenseInfo/LicenseInfo';
import LicensesInstruction from './LicensesInstruction';
import { useCallback, useEffect, useState } from 'react';
import { InfoMessageType } from 'src/Components/InfoBar/InfoBar';

interface ILicensesUserParams {
    licensesInfo: ILicensesInfo;
    clinicId: string;
    setInfo: (message: string, type: InfoMessageType) => void;
    updatePageLoader: (load: boolean) => void;
    isSuiteLicense: boolean;
}
const LicensesUser: React.FC<ILicensesUserParams> = ({ licensesInfo, clinicId, setInfo, updatePageLoader, isSuiteLicense }) => {
    const [updatedLicenceInfo, setUpdatedLicenceInfo] = useState<ILicensesInfo>(licensesInfo);
    const [licenseStatistics, setLicenseStatistics] = useState<ILicenseStats>({ total: 0, inUse: 0 });

    const getDetailsByEntitlementId = useCallback((entitlementId: string) => {
        const filteredDetails = (updatedLicenceInfo.clinicLicenceUserInfo || []).filter(
            (userInfo) => userInfo.entitlementId === entitlementId
        );
        return filteredDetails;
    }, [updatedLicenceInfo]);
    
    useEffect(() => {
        var total = 0;
        var inUse = 0;
        updatedLicenceInfo.licenceInfo.forEach(item => {
            total += item.maximumSeats;
            inUse += item.maximumSeats - item.availableSeats;
        });
        setLicenseStatistics({ total, inUse });
    }, [updatedLicenceInfo])
    
    useEffect(() => {
        setUpdatedLicenceInfo(licensesInfo)
    }, [licensesInfo])


    return (
        <>
            {licenseStatistics.total > 0 &&
                <>
                    <div className="row">
                        <div className='col instruction'>
                            {(licenseStatistics.inUse > 0) && (licenseStatistics.inUse === licenseStatistics.total) &&
                                <LicensesInstruction />
                            }
                        </div>
                    </div>
                    <div>
                        {
                            updatedLicenceInfo.licenceInfo.map((item) => {
                                const detailsForEntitlementId = getDetailsByEntitlementId(item.entitlementId);
                                const licenseStatsTotal = item.maximumSeats;
                                const licenseStatsInUse = detailsForEntitlementId.length;
                                const licenseStats: ILicenseStats = ({total: licenseStatsTotal, inUse: licenseStatsInUse});

                                return(
                                    <LicenseInfo
                                        licensesList={detailsForEntitlementId}
                                        noOfUnusedLicenses={item.maximumSeats - detailsForEntitlementId.length}
                                        licenseEndDate={item.licenseEndDate}
                                        clinicId={clinicId}
                                        key={item.entitlementId}
                                        setInfo={setInfo}
                                        updatePageLoader={updatePageLoader}
                                        licenseType={item.licenseType}
                                        isSuiteLicense={isSuiteLicense}
                                        licenseStatistics={licenseStats}
                                    />
                                ) 
                            })
                        }
                    </div>
                </>
            }
        </>
    )
}

export default LicensesUser;